import {AccountSummaryRepositoryAPI} from '@/profile-creation-wizard/components/for-completion/infra/repository/AccountSummaryRepositoryAPI';
import {ProfileCompletionRepositoryAPI} from '@/profile-creation-wizard/components/for-completion/infra/repository/ProfileCompletionRepositoryAPI';
import LanguageSearcher from '@/profile-creation-wizard/components/for-creation/repository/LanguageSearcher';
import {CategorizationRepository} from '@/common/repositories/CategorizationRepository';
import {FreelancerTagsService} from '@/profile-creation-wizard/components/for-creation/FreelancerTagsService';
import {PricingStatService} from '@/profile-creation-wizard/components/for-creation/PricingStatService';
import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
import {ProfileCreationService} from '@/profile-creation-wizard/components/for-creation/ProfileCreationService';
import {BlockedCountryRepository} from '@/common/repositories/blocked-countries/BlockedCountryRepository';
import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
import IndustryExpertiseRepository from '@/profile-creation-wizard/components/for-creation/repository/IndustryExpertiseRepository';
import {AccountSummaryRepository} from '@/profile-creation-wizard/components/for-completion/domain/AccountSummaryRepository';
import {ProfileCompletionRepository} from '@/profile-creation-wizard/components/for-completion/domain/ProfileCompletionRepository';
import {InjectionKey} from 'vue';
import FunctionalSkillsRepository from '@/profile-creation-wizard/components/for-creation/repository/FunctionalSkillsRepository';
import {ExperienceDomainService} from '../components/for-completion/domain/experience/ExperienceDomainService';
import {ExperienceRepositoryAPI} from '../components/for-completion/infra/repository/ExperienceRepositoryAPI';
import {ApplicationStateRepository} from '../components/for-completion/domain/application-state/ApplicationStateRepository';
import {ApplicationStateRepositoryAPI} from '../components/for-completion/infra/repository/ApplicationStateRepositoryAPI';
import {AuthenticationRepository} from '../components/for-completion/domain/authentication/AuthenticationRepository';
import {AuthenticationRepositoryAPI} from '../components/for-completion/infra/repository/AuthenticationRepositoryAPI';

// Domain services
const registeredDomainServices = {
    experienceDomainService: Symbol('experienceDomainService') as InjectionKey<ExperienceDomainService>,
};

function getRegisteredDomainServices() {
    return {
        [registeredDomainServices.experienceDomainService as symbol]: new ExperienceDomainService(new ExperienceRepositoryAPI()),
    };
}

// Repositories
const registeredRepositories = {
    accountSummaryRepository: Symbol('accountSummaryRepository') as InjectionKey<AccountSummaryRepository>,
    applicationStateRepository: Symbol('applicationStateRepository') as InjectionKey<ApplicationStateRepository>,
    authenticationRepository: Symbol('authenticationRepository') as InjectionKey<AuthenticationRepository>,
    blockedCountriesRepository: Symbol('blockedCountriesRepository') as InjectionKey<BlockedCountryRepository>,
    categorizationRepository: Symbol('categorizationRepository') as InjectionKey<CategorizationRepository>,
    creationFormValidation: Symbol('creationFormValidation') as InjectionKey<CreationFormValidation>,
    languageSearcher: Symbol('languageSearcher') as InjectionKey<LanguageSearcher>,
    profileCompletionRepository: Symbol('profileCompletionRepository') as InjectionKey<ProfileCompletionRepository>,
    trackingRepository: Symbol('trackingRepository') as InjectionKey<TrackingRepository>,
    industryExpertiseRepository: Symbol('industryExpertiseRepository') as InjectionKey<IndustryExpertiseRepository>,
    functionalSkillsRepository: Symbol('functionalExpertiseRepository') as InjectionKey<FunctionalSkillsRepository>,
};

function getRegisteredRepositories() {
    return {
        [registeredRepositories.accountSummaryRepository as symbol]: new AccountSummaryRepositoryAPI(),
        [registeredRepositories.applicationStateRepository as symbol]: new ApplicationStateRepositoryAPI(),
        [registeredRepositories.authenticationRepository as symbol]: new AuthenticationRepositoryAPI(),
        [registeredRepositories.blockedCountriesRepository as symbol]: new BlockedCountryRepository(),
        [registeredRepositories.categorizationRepository as symbol]: new CategorizationRepository(),
        [registeredRepositories.creationFormValidation as symbol]: new CreationFormValidation(),
        [registeredRepositories.languageSearcher as symbol]: new LanguageSearcher(),
        [registeredRepositories.profileCompletionRepository as symbol]: new ProfileCompletionRepositoryAPI(),
        [registeredRepositories.trackingRepository as symbol]: new TrackingRepository(),
        [registeredRepositories.industryExpertiseRepository as symbol]: new IndustryExpertiseRepository(),
        [registeredRepositories.functionalSkillsRepository as symbol]: new FunctionalSkillsRepository(),
    };
}

// Services
const registeredServices = {
    freelancerTagsService: Symbol('freelancerTagsService') as InjectionKey<FreelancerTagsService>,
    pricingStatsService: Symbol('pricingStatsService') as InjectionKey<PricingStatService>,
    profileCreationService: Symbol('profileCreationService') as InjectionKey<ProfileCreationService>,
};

function getRegisteredServices() {
    return {
        [registeredServices.freelancerTagsService as symbol]: new FreelancerTagsService(),
        [registeredServices.pricingStatsService as symbol]: new PricingStatService(),
        [registeredServices.profileCreationService as symbol]: new ProfileCreationService(),
    };
}

export const DI = {
    ...registeredDomainServices,
    ...registeredRepositories,
    ...registeredServices,
};

export const RegisteredDependencies = {
    all: () => ({
        ...getRegisteredDomainServices(),
        ...getRegisteredRepositories(),
        ...getRegisteredServices(),
    }),
    injectionKeys: DI,
};
